import React from 'react'

class SSOSuccess extends React.Component {
    componentDidMount() {
        setTimeout(()=>{
            window.close();
        },10000)
    }

    render() {
        return(
            <div className='card'>
                Successfully logged in. Your {this.props.product} is now part of the Screenbeam Cloud Network.
                <p>This window will automatically close.</p>
                <button onClick={()=>{window.close()}}>Close Window</button>
            </div>
        )
    }
}

export default SSOSuccess;